import { render, staticRenderFns } from "./TCMConsultationPrescriptionRecord.vue?vue&type=template&id=66884d1c&scoped=true&"
import script from "./TCMConsultationPrescriptionRecord.vue?vue&type=script&lang=js&"
export * from "./TCMConsultationPrescriptionRecord.vue?vue&type=script&lang=js&"
import style0 from "./TCMConsultationPrescriptionRecord.vue?vue&type=style&index=0&id=66884d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66884d1c",
  null
  
)

export default component.exports